module.exports = __webpack_public_path__ + "resources/icon-letter-head-close.045f22431bca9364.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-rolling/img/icon-letter-head-close.png
// module id = 827
// module chunks = 0 1